import MacbookPro from '../assets/images/macbookpro.png'
import Timios from '../assets/images/timios.png'
import CoverTree from '../assets/images/coverTree.png'
import Sepal from '../assets/images/sepal.png'
import HealthUno from '../assets/images/healthuno.png'
import Scarto from '../assets/images/scarto.png'

export const data = [
    {
        background: "bg-[#FF761F]",
        buttonTextColor: "!text-[#FF761F]",
        image: MacbookPro,
        title: "CBREX",
        subtitle: "Global Recruiter Exchange",
        description: `We, at Avian Design, engaged directly with Chandan Sardeshmukh (CPO & Co-founder of CBREX) and their development team to gather insights and implement the aspired design style into their existing system.`,
        alt: "CBREX"
    },
    {
        background: "bg-[#8053A1]",
        buttonTextColor: "!text-[#8053A1]",
        imageHeight: 9,
        image: Timios,
        title: "Timios",
        description: `Timios brings to our children an age-appropriate range of products that are loaded with goodness on the inside and fun on the outside! We at Avian Design engaged with Aswani Chaitanya, founder of Timios, to evaluate their existing platform and build a new digital experience focusing mainly on the end-users.`,
        alt: "Timios"
    },
    {
        background: "bg-[#B1F6BA]",
        buttonTextColor: "!text-[#B1F6BA]",
        ringColor: "bg-[#267731] !ring-[#267731]",
        textColor: "text-[#093649]",
        imageHeight: 9,
        subTitleColor: "text-[#1B1B1B]/90",
        titleColor: "text-[#267731]",
        image: CoverTree,
        title: "Cover Tree",
        subtitle: "An Insurance company that helps users to find the best insurance that suites them.",
        description: `We, at Avian Design, engaged directly with the Adarsh Rachmale and Divyansh Malhotra (Co-founders) to gather insights and implement the aspired design style into their existing system.`,
        alt: "Cover Tree"
    },
    {
        background: "bg-[#0A1F2D]",
        buttonTextColor: "!text-[#0A1F2D]",
        imageHeight: 11,
        image: Sepal,
        title: "Sepal",
        subtitle: "Experience complete protection and ultimate comfort!",
        description: `Sepal is a Consumer Electronics organization aiming to lead an integral sect of the two-wheeler industry to make the life of a daily commuter safer, more comfortable & enjoyable through the use of IoT.`,
        alt: "Sepal Mobile Application"
    },
    {
        background: "bg-[#28A3DA]",
        buttonTextColor: "!text-[#28A3DA]",
        imageHeight: 11.5,
        image: HealthUno,
        title: "Health Uno",
        subtitle: "The health care service you trust to care!",
        description: `HealthUno is a Chennai-based healthcare platform that provides a digital network of experts to the Indian community. We at Avian Design engaged with Dr. Anand Punniakoti, Chief Medical Officer at HealthUno, to bring life to their new platform and build a digital experience focusing on affordable and effective online healthcare.`,
        alt: "HealthUno Mobile Application"
    },
    {
        background: "bg-[#F88A35]",
        buttonTextColor: "!text-[#F88A35]",
        imageHeight: 11,
        image: Scarto,
        title: "Scarto",
        subtitle: "Let’s step towards a sustainable lifestyle with Scarto",
        description: `Scarto aims to build a product that is a sustainable way to help people in need and fight the environment in the balance against food waste.`,
        alt: "Scarto Mobile Application"
    },
]